/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { AgencyProfileLinkResponseDtoLabel } from './agencyProfileLinkResponseDtoLabel';
import type { AgencyProfileLinkResponseDtoType } from './agencyProfileLinkResponseDtoType';

export interface AgencyProfileLinkResponseDto {
  id: string;
  type: AgencyProfileLinkResponseDtoType;
  url: string;
  /** @nullable */
  label: AgencyProfileLinkResponseDtoLabel;
}
